import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { UserDealerModel } from '../../types/UserDealerModel';

export type UserDealerState = {
  userDealer: UserDealerModel | null;
  isUserDealerDataLoading: boolean;
};

const initialState: UserDealerState = {
  userDealer: null,
  isUserDealerDataLoading: false,
};

const userDealerSlice = createSlice({
  name: 'userDealer',
  initialState,
  reducers: {
    storeUserDealer(state, action: PayloadAction<UserDealerModel>) {
      state.isUserDealerDataLoading = false;
      state.userDealer = action.payload;
    },
    loadingUserDealer(state) {
      state.isUserDealerDataLoading = true;
    },
    updateUserDealerSelectedDealerId(state, action: PayloadAction<string>) {
      if (state.userDealer) {
        state.userDealer!.dealerId = action.payload;
      }
      state.isUserDealerDataLoading = false;
    },
  },
});

export const { storeUserDealer, loadingUserDealer, updateUserDealerSelectedDealerId } =
  userDealerSlice.actions;
export default userDealerSlice.reducer;
